import React from 'react';
import SvgIcon from './svgIcon';

const SvgLogout = props => {
  return (
    <SvgIcon width={24} height={24} {...props}>
      <path
        fill="currentColor"
        d="M15,16.414 L13.586,15 L15.586,13 L9,13 L9,11 L15.586,11 L13.586,9 L15,7.586 L19.414,12 L15,16.414 Z M16,18 L16,20 L6,20 C5.448,20 5,19.552 5,19 L5,5 C5,4.448 5.448,4 6,4 L16,4 L16,6 L7,6 L7,18 L16,18 Z"
      />
    </SvgIcon>
  );
};

export default SvgLogout;
